import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { gatewayStatusStr, gatewayVariant } from '@/constants/gatewayStatus'

export default [
    {
        field: 'user_id',
        title: i18n.t('label.user_id'),
        sortable: true,
        width: 70,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.first_and_last_name'),
        sortable: false,
        width: 140,
        textAlign: 'center'
    },
    {
        field: 'wage',
        sortable: true,
        title: i18n.t('label.wage') + ' (' + i18n.t('label.rial') + ')',
        width: 140,
        textAlign: 'center'
    },
    {
        field: 'fa_gateway_name',
        sortable: false,
        title: i18n.t('label.gateway_title'),
        width: 140,
        textAlign: 'center'
    },
]